module.exports = __webpack_public_path__ + "img/solution-software-system-pic-7.83835736.png";